'use client';

import {Header} from '@ui-kit/src/Header';
import {HeaderProps} from '@ui-kit/src/Header/Header.types';
import {useCallback} from 'react';

import {AuthController} from '@web-catalog/components/Auth/AuthController';
import {AuthHeaderComponent} from '@web-catalog/components/Auth/AuthHeaderComponent';
import {AuthSnackBar} from '@web-catalog/components/Auth/AuthSnackBar';
import {DownloadButton} from '@web-catalog/components/DownloadButton';
import {HeaderSearch, MobileMenu} from '@web-catalog/components/Header/parts';
import {Category} from '@web-catalog/components/Header/parts/MobileMenu/MobileMenu.entity';
import {useMenuAnalytics} from '@web-catalog/components/Header/useMenuAnalytics';

import {useOmicronClientFlag, useOmicronFlag} from '@web-catalog/hooks/omicron';

import {useHeaderAnalytics} from '@web-catalog/utils/analytics/headerAnalytics/useHeaderAnalytics';

import styles from './StrapiHeader.module.scss';
import useActiveLinkOrder, {
  APPS_LINK_ORDER,
  KIOSK_LINK_ORDER,
} from './useActiveLinkOrder';

export const StrapiHeader = ({
  handleLinkClick,
  hideSearchButton,
  ...props
}: HeaderProps & {
  handleLinkClick?: HeaderProps['onLinkClick'];
  hideSearchButton?: boolean;
}) => {
  const {logLinkClick} = useHeaderAnalytics();

  const {logMenuOpen, logMenuClose} = useMenuAnalytics();

  const handleChangeMenu = (
    menuState: boolean,
    changeMenuState: () => void,
  ) => {
    changeMenuState();

    if (menuState) {
      return logMenuOpen();
    }

    return logMenuClose();
  };
  const activeLinkOrder = useActiveLinkOrder();

  //Костыль для киоска в списке ссылок хедере

  const isLinkExist = (name: string) => {
    return props.links.some((elem) => elem.title === name);
  };

  const webAvailableKioskPage = useOmicronFlag('ENABLE_KIOSK_PAGE');

  const linkOrder = () => {
    if (activeLinkOrder === KIOSK_LINK_ORDER) {
      return isLinkExist('Киоск') && webAvailableKioskPage
        ? activeLinkOrder
        : APPS_LINK_ORDER;
    }

    return activeLinkOrder;
  };

  const webAvailableAutoLoginType = useOmicronClientFlag('WEB_AUTO_LOGIN');

  const onLinkClick = useCallback<NonNullable<HeaderProps['onLinkClick']>>(
    (link, event) => {
      logLinkClick(link);
      if (handleLinkClick) {
        handleLinkClick(link, event);
      }
    },
    [handleLinkClick, logLinkClick],
  );

  const links = webAvailableKioskPage
    ? props.links
    : props.links.filter((elem) => elem.title !== Category.KIOSK);

  return (
    <Header
      {...props}
      links={links}
      onLinkClick={onLinkClick}
      activeLinkOrder={linkOrder()}
      rightSideContent={({isTopScroll}) => (
        <div className={styles.wrapper}>
          {!hideSearchButton && <HeaderSearch />}

          <DownloadButton
            isTopScroll={isTopScroll}
            labelDesktop="Скачать RuStore"
            labelMobile="Скачать"
          />
          {webAvailableAutoLoginType !== 'none' && (
            <>
              <AuthHeaderComponent />
              <AuthController />
              <AuthSnackBar />
            </>
          )}
        </div>
      )}
      mobileMenu={{
        mobileMenuTitle: 'Меню',
        mobileMenuNode: ({handleHideMenu, isMenuOpened, menuRef}) => (
          <MobileMenu
            isOpen={isMenuOpened}
            handleClose={() => handleChangeMenu(isMenuOpened, handleHideMenu)}
            menuRef={menuRef}
          />
        ),
      }}
    />
  );
};
